import connect from './connect';

export { OutForSignatureTableBody } from './OutForSignatureTableBody';

export default connect;
